import React, { Component } from "react";
import { IStore } from "@my-dld/reducers/store";
import { connect } from "react-redux";
import { IUser } from "@10x/sso";
import { getUser } from "@my-dld/utils/User";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import Strings from "@my-dld/assets/strings";
import { bindActionCreators, Dispatch } from "redux";
import * as UActions from "@my-dld/actions/UserActions";
import { MessageData } from "@my-dld/reducers/TempData";
import { Constants as FGConstants, FGContextWrapper } from "@10x/feature-gate";
import { dispatch } from "@my-dld/utils/StoreUtils";


export interface IAppContext {
	user?: IUser;
	path: string;
	query?: string;
	hash?: string;
	isLoading: boolean;
	message?: string;
	info?: MessageData;
	error?: string;
	paths?: PathInfo[];
	loaderExtraClass?: string;
	componentId?: string;
	isUserRefreshing: boolean;
}

type UT = typeof UActions;

interface Props extends IAppContext, UT {
}

export interface PathInfo {
	path?: string;
	id: string;
	label: LocaleValue;
}

const defaultContext: IAppContext = {
	user: undefined,
	path: "/",
	isLoading: false,
	isUserRefreshing: false,
};

export const AppContext = React.createContext( defaultContext );

interface State {
}

class AppContextWrapper extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true
		};
	}

	componentDidMount() {
		this.props.refreshUser();
		this.updateFeatureGate();
	}

	updateFeatureGate = () => {
		dispatch( FGConstants.FG_UPDATE,
			window.AppInfo.featureGate ?? {}
		);
	};

	render() {
		const { children, refreshUser, login, logout, ...props } = this.props;
		if ( props.isUserRefreshing ) {
			if ( this.props.componentId === "mydld" )
				return <div
					style={ {
						minHeight: 100,
						alignItems: "center",
						justifyContent: "center",
						width: "100%",
						display: "flex",
					} }>
					<div>{ Strings.loading }</div>
				</div>;
			return <span/>;

		}
		return <AppContext.Provider value={ props }>
			<FGContextWrapper>
				{ children }
			</FGContextWrapper>
		</AppContext.Provider>;
	}
}

const mapStateToProps = ( state: IStore, ownProps: Partial<IAppContext> & { children?: any } ): IAppContext => {
	//let homeNav = state.HomeNav;
	return {
		user: state.User.user ? getUser() : undefined,
		path: state.router.location.pathname,
		query: state.router.location.search,
		hash: state.router.location.hash,
		isLoading: state.TempData.isLoading,
		error: state.TempData.error,
		message: state.TempData.message,
		info: state.TempData.info,
		loaderExtraClass: state.TempData.loaderExtraClass,
		isUserRefreshing: state.TempData.isRefreshing,
	};
};

function mapDispatchToProps( dispatch: Dispatch ) {
	return bindActionCreators( UActions, dispatch );
}

export default connect( mapStateToProps, mapDispatchToProps )( AppContextWrapper );
//export default x;
